<template>
  <div>
    <p class="text-h6-nolineht mb-1 mt-2">District population (2020)</p>
    <p class="text-body-2-small">(Where appropriate &amp; where data is available, totals below reflect prisoner-adjusted population. Otherwise, population reflects 2020 Census data from the <em>P.L.94-171 redistricting data file</em>.)</p>
    <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <tbody data-cy=dist-pop>
          <tr>
            <td>Total population</td>
            <td class="text-right">
              {{ parseFloat(selectedDistrictData.totpop20).toLocaleString() }}
            </td>
          </tr>
          <tr>
            <td>Voting age pop.</td>
            <td class="text-right">
              {{ parseFloat(selectedDistrictData.vaptotal20).toLocaleString() }}
            </td>
          </tr>
          <!-- <tr>
            <td>Adults in correctional facilities</td>
            <td class="text-right">
              {{
                parseFloat(
                  selectedDistrictData.adult_corr_facilites20
                ).toLocaleString()
              }}
            </td>
          </tr> -->
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table dense class="table-wrap-scoped mb-1">
      <template v-slot:default>
        <tbody data-cy=dist-avg-pop>
          <tr>
            <td class="font-italic">Average district pop. in {{selectedDistrictData.stusps}}</td>
            <td class="text-right font-italic">
              <span>{{ stateWideDistrictTypeData.avgpop }}</span>
            </td>
          </tr>
          <tr v-if="+selectedDistrictData.deviationnum !== 0">
            <td>
              District
              <span
                v-if="+selectedDistrictData.deviationnum > 0"
                class="font-weight-bold text-needtoshrink-color"
                >above avg.</span
              >
              <span
                v-else-if="+selectedDistrictData.deviationnum < 0"
                class="font-weight-bold text-needtoexpand-color"
                >below avg.</span
              >
              by...
            </td>
            <td
              v-if="
                +selectedDistrictData.deviationnum === 1 ||
                +selectedDistrictData.deviationnum === -1
              "
              class="text-right"
            >
              <span
                v-if="+selectedDistrictData.deviationnum > 0"
                class="font-weight-bold text-needtoshrink-color"
              >
                {{ (+selectedDistrictData.deviationnum).toLocaleString() }}
                person</span
              >
              <span
                v-if="+selectedDistrictData.deviationnum < 0"
                class="font-weight-bold text-needtoexpand-color"
              >
                {{
                  Math.abs(+selectedDistrictData.deviationnum).toLocaleString()
                }}
                person</span
              >
            </td>
            <td v-else class="text-right">
              <span
                v-if="+selectedDistrictData.deviationnum > 0"
                class="font-weight-bold text-needtoshrink-color"
              >
                {{ (+selectedDistrictData.deviationnum).toLocaleString() }}
                people</span
              >
              <span
                v-if="+selectedDistrictData.deviationnum < 0"
                class="font-weight-bold text-needtoexpand-color"
              >
                {{
                  Math.abs(+selectedDistrictData.deviationnum).toLocaleString()
                }}
                people</span
              >
            </td>
          </tr>
          <tr>
            <td>% difference from avg.</td>
            <td class="text-right">
              <span
                v-if="+selectedDistrictData.deviationpct > 0.001"
                class="font-weight-bold text-needtoshrink-color"
                >{{
                  (selectedDistrictData.deviationpct * 100).toFixed(1)
                }}%</span
              >
              <span
                v-if="+selectedDistrictData.deviationpct < -0.001"
                class="font-weight-bold text-needtoexpand-color"
                >{{
                  (selectedDistrictData.deviationpct * 100).toFixed(1)
                }}%</span
              >
              <span
                v-if="
                  +selectedDistrictData.deviationpct >= -0.001 &&
                  +selectedDistrictData.deviationpct <= 0.001
                "
                class="font-weight-regular"
                >0%</span
              >
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
export default {
name: 'DistrictPopTables',
props: ['selectedDistrictData', 'stateWideDistrictTypeData'],
components: {},
data: function () {
return {};
},
mounted: function () {},
methods: {},
watch: {
  // selectedDistrictData:function(val){
  //   console.log(val)
  // }
},
computed: {}
};
</script>
<style>
.text-body-2-small {
    font-size: 0.775rem !important;
    font-weight: 400;
margin-bottom: 5px !important;
letter-spacing: 0.0178571429em !important;
    font-family: "Roboto", sans-serif !important;
}
</style>